import { EnumToUnion } from 'types'

export enum PtStatus {
  Pending = 'pending',
  Success = 'success',
  Fail = 'fail',
}

export type StatusType = EnumToUnion<typeof PtStatus>
